import { StateAssert } from '@csp/csp-common-model';
import { ScheduleRequestRef } from '@csp/csp-common-scheduling';

const DELIMITER = '||';

/** A string key identifying the combination of scheduleCode and requestCode */
export type ScheduleRequestRefKey = string;

const toKey = (ref: ScheduleRequestRef): ScheduleRequestRefKey => ref.scheduleCode + DELIMITER + ref.requestCode;

const toScheduleRequestRef = (keys: ScheduleRequestRefKey[]): ScheduleRequestRef[] => {
  const separatorKey = keys.map(key => key.split(DELIMITER));
  const parts = separatorKey.find(key => key);

  if (parts) {
    StateAssert.isTrue(parts.length === 2, 'expected scheduleCode and scheduleCode');
  }

  return separatorKey.map(key => {
    StateAssert.isDefined(key[0]);
    StateAssert.isDefined(key[1]);
    return {
      scheduleCode: key[0],
      requestCode: key[1],
    };
  });
};

const fromScheduleRequestRefs = (requestRefs: ScheduleRequestRef[]): ScheduleRequestRefKey[] =>
  requestRefs.map(requestRef => toKey(requestRef));

export const ScheduleRequestRefKey = {
  /** unit test purpose */
  toKey,
  toScheduleRequestRef,
  fromScheduleRequestRefs,
};
